import React from 'react';
import { array, oneOfType, string } from 'prop-types';
import classNames from 'classnames';
import { map } from 'ramda';

import css from './DataWithLabel.module.css';

const DataWithLabel = (props) => {
  const {
    className,
    labelClassName,
    valueClassName,
    label,
    value,
  } = props;
  const valueIsArray = typeof value === 'object';
  const classes = classNames(css.root, className);
  const labelClasses = classNames(labelClassName || css.label);
  const valueClasses = classNames(valueClassName || css.value);

  return (
    <div className={classes}>
      <span className={labelClasses}>{label}</span>
      {valueIsArray ? (
        <ul className={css.list}>
          {map(value => (
            <li key={value} className={valueClasses}>{value}</li>
          ), value)}
        </ul>
      ) : (
        <span className={valueClasses}>{value}</span>
      )}
    </div>
  )
}

DataWithLabel.defaultProps = {
  className: null,
  labelClassName: null,
  valueClassName: null,
};

DataWithLabel.propTypes = {
  className: string,
  labelClassName: string,
  valueClassName: string,
  label: string.isRequired,
  value: oneOfType([string, array]).isRequired,
};

export default DataWithLabel;